import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance"; 
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TextField,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import { toast } from "react-toastify";

import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
const defaultMenus = [
  {
    key: "Dashboard",
    slug: "dashboard",
    route: "/dashboard",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Manage Users",
    slug: "manage-users",
    route: "/userManagement",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Lottery Management",
    slug: "lottery-management",
    route: "/ManageLotteries",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Jackpot Management",
    slug: "jackpot-management",
    route: "/ManageJackpot",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Manage Payouts",
    slug: "manage-payouts",
    route: "/ManagePayout",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "KYC Verifications",
    slug: "kyc-verifications",
    route: "/ManageKYC",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Manage Withdraw",
    slug: "manage-withdraw",
    route: "/ManageWithdraw",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Payment Management",
    slug: "Payment-Management",
    route: "/manageWithdrawalMethods",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Report Management",
    slug: "report-management",
    route: "/report-management",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Manage Promotions",
    slug: "manage-promotions",
    route: "/ManagePromotion",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Manage Pages",
    slug: "manage-pages",
    route: "/manage-pages",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Roles & Permissions",
    slug: "roles-permissions",
    route: "/roles-permissions",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    key: "Notification Management",
    slug: "notification-management",
    route: "/ManageNotificationTemplate",
    permissions: {
      view: false,
      edit: false,
      delete: false,
      add: false,
      export: false,
    },
  },
  {
    "key": "My Account",
    "slug": "My Account",
    "route": "/my-account",
    "permissions": {
      "view": true,
      "edit": true,
      "delete": true,
      "add": true,
      "export": true
    },
  },
  {
    "key": "Edit Account",
    "slug": "Edit Account",
    "route": "/edit-account",
    "permissions": {
      "view": true,
      "edit": true,
      "delete": true,
      "add": true,
      "export": true
    },
  
  },
  {
    "key": "Reset Password",
    "slug": "Reset Password",
    "route": "/reset-password",
    "permissions": {
      "view": true,
      "edit": true,
      "delete": true,
      "add": true,
      "export": true
    },
  
  }
];

const useStyles = makeStyles((theme) => ({
  ...styles,
  formContainer: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "20px",
    background: "#f8f9fa",
    borderRadius: "8px",
    flexWrap: "wrap",
  },
  inputField: {
    flex: 1,
    minWidth: "250px",
  },
  formControl: {
    flex: 1,
    minWidth: "200px",
  },
  menuItemContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  deleteButton: {
    color: "red",
  },
  createButton: {
    backgroundColor: "#4CAF50",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "5px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#45a049",
    },
  },
  tableSection: {
    marginTop: "30px",
    padding: "20px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
}));

const mergeArrays = (arr1, arr2) => {
  const map = new Map(arr1.map((item) => [item.key, item]));
  arr2.forEach((item) => map.set(item.key, { ...map.get(item.key), ...item }));
  return [...map.values()];
};

export default function ManageRoles() {
  const classes = useStyles();
  const [roleName, setRoleName] = useState("");
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [allMenus, setAllMenus] = useState([]);
  const [changedData, setChangedData] = useState([]);
  const [selectOpen, setSelectOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    fetchRoles();
  }, []);
  const handlePermissionChange = (menuId, perm, per, slug, route) => {
    setAllMenus((prevMenus) =>
      prevMenus.map((menu) =>
        menu.key === menuId
          ? {
            ...menu,
            permissions: {
              ...menu.permissions,
              [perm]: !menu.permissions[perm],
            },
          }
          : menu
      )
    );
    setChangedData((prev) => {
      const existingIndex = prev.findIndex((item) => item.key === menuId);

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          permissions: {
            ...updated[existingIndex].permissions,
            [perm]: !per,
          },
        };
        return updated;
      } else {
        return [
          ...prev,
          {
            key: menuId,
            slug: slug,
            route: route,
            permissions: {
              [perm]: !per,
            },
          },
        ];
      }
    });
  };
  const fetchRoles = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getRoles`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response.data.role) {
          setRoles(response.data.role);
        }
      })
      .catch((error) => console.error("Error fetching roles:", error));
  };
  const fetchPermissions = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getAssignPermissionsToRole?roleId=${selectedRole}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response.data) {
        setAllMenus(mergeArrays(defaultMenus, response?.data?.data?.menus));
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!selectedRole) return;

    fetchPermissions();
  }, [selectedRole]);

  const handleAssignPermissionsToRole = () => {
    const token = localStorage.getItem("token");
    axios
      .post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/assignPermissionsToRole`,
        {
          roleId: selectedRole,
          permissions: changedData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => {
        console.log(response, "response.status");

        toast.success(response?.data?.message || "Role created successfully!");
        fetchPermissions();
      })
      .catch((error) => {
        console.log(error, "error");

        toast.error(error?.response?.data?.message || "Error creating role.");
      });
  };

  const handleCreateRole = () => {
    if (!roleName.trim()) {
      setError("Role name cannot be empty");
      return;
    }

    setError("");

    const token = localStorage.getItem("token");
    axios
      .post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/createRole`,
        { name: roleName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => {
        if (response.status == 201) {
          toast.success(
            response?.data?.message || "Role created successfully!"
          );
          setRoleName("");
          fetchRoles();
        } else {
          toast.error(response?.data?.message || "Error creating role.");
        }
      })
      .catch((error) =>
        toast.error(error?.response?.data?.message || "Error creating role.")
      );
  };
  const handleDeleteRole = async (roleId) => {
    const token = localStorage.getItem("token");

    try {
      const confirmResult = await Swal.fire({
        title: `Are you sure you want to delete this role?`,
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return axios
            .delete(
              `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/deleteRole/${roleId}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((res) => {
              setRoles((prev) => prev.filter((r) => r._id !== roleId));
              if (selectedRole === roleId) {
                setSelectedRole("");
              }
              toast.success(res.data.message || "Role deleted successfully");
              return res;
            })
            .catch((error) => {
              console.error("Delete error", error);
              Swal.showValidationMessage("Failed to delete role");
              toast.error("Failed to delete role");
            });
        },
      });

      if (confirmResult.isConfirmed) {
        console.log(`${roleId} successfully deleted`);
      }
    } catch (err) {
      console.error("Unexpected error during delete", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Manage Roles</h4>
          </CardHeader>
          <CardBody>
            <div className={classes.formContainer}>
              <TextField
                className={classes.inputField}
                label="Enter Role Name"
                variant="outlined"
                fullWidth
                value={roleName}
                onChange={(e) => {
                  setRoleName(e.target.value);
                  if (error) setError("");
                }}
                error={!!error}
                helperText={error}
              />
              <Button
                className={classes.createButton}
                onClick={handleCreateRole}
              >
                Create Role
              </Button>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="role-select-label">Select Role</InputLabel>
                <Select
                  labelId="role-select-label"
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e.target.value)}
                  label="Select Role"
                  open={selectOpen}
                  onOpen={() => setSelectOpen(true)}
                  onClose={() => setSelectOpen(false)}
                  renderValue={(selected) => {
                    const role = roles.find((r) => r._id === selected);
                    return role?.name || "";
                  }}
                >
                  {roles.map((role) => (
                    <MenuItem key={role._id} value={role._id}>
                      <div className={classes.menuItemContent}>
                        <span>{role.name}</span>
                        <IconButton
                          className={classes.deleteButton}
                          edge="end"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectOpen(false);
                            setTimeout(() => handleDeleteRole(role._id), 0);
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {selectedRole ? (
              loading ? (
                <div
                  style={{
                    height: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <>
                  <div className={classes.tableSection}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <b>Menu</b>
                            </TableCell>
                            <TableCell>
                              <b>View</b>
                            </TableCell>
                            <TableCell>
                              <b>Edit</b>
                            </TableCell>
                            <TableCell>
                              <b>Delete</b>
                            </TableCell>
                            <TableCell>
                              <b>Add</b>
                            </TableCell>
                            <TableCell>
                              <b>Export</b>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {allMenus?.map((menu) => (
                            <TableRow key={menu._id}>
                              <TableCell>{menu.key}</TableCell>
                              {["view", "edit", "delete", "add", "export"].map(
                                (perm) => (
                                  <TableCell key={perm}>
                                    <Checkbox
                                      checked={menu.permissions[perm]}
                                      onChange={() =>
                                        handlePermissionChange(
                                          menu.key,
                                          perm,
                                          menu.permissions[perm],
                                          menu.slug,
                                          menu.route
                                        )
                                      }
                                      disabled={
                                        ["/my-account", "/edit-account", "/reset-password"].includes(
                                          menu.route
                                        )
                                      }
                                    />
                                  </TableCell>
                                )
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAssignPermissionsToRole}
                    >
                      Save Changes
                    </Button>
                  </div>
                </>
              )
            ) : (
              <div
                className={classes.tableSection}
                style={{
                  marginTop: "20px",
                  color: "gray",
                  fontWeight: 500,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "150px",
                }}
              >
                Please select a role to show the permissions.
              </div>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
